/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Legend,
    ResponsiveContainer,
    Tooltip
} from 'recharts';
import PropTypes from 'prop-types';

export default function SerieHistoryBySkillChart({ serieHistory }) {
    const [hiddenSeries, setHiddenSeries] = useState([]);

    const handleLegendClick = (elem) => {
        const { dataKey } = elem;
        if(hiddenSeries.includes(dataKey)) {
            setHiddenSeries(hiddenSeries.filter((key) => key !== dataKey));
        } else {
            setHiddenSeries([...hiddenSeries, dataKey]);
        }
    };

    if(!serieHistory || serieHistory.length === 0) {
        return <p>Aucune donnée de compétence disponible pour le graphique radar.</p>;
    }

    const allSkills = Array.from(new Set(serieHistory.flatMap((entry) => entry.scoresBySkill.map((skill) => skill.name))));

    const chartData = allSkills.map((skillName) => {
        const skillEntry = { subject: skillName, fullMark: 100 };
        serieHistory.forEach((userEntry, index) => {
            const userSkill = userEntry.scoresBySkill.find((skill) => skill.name === skillName);
            skillEntry[`history_${index}`] = userSkill ? (userSkill.goodAnswers / userSkill.nbTotalQuestions) * 100 : 0;
        });
        return skillEntry;
    });

    const legendFormatter = (value, entry) => {
        const { dataKey } = entry;
        const isHidden = hiddenSeries.includes(dataKey);
        return <span style={{ color: isHidden ? '#ccc' : '#000' }}>{value}</span>;
    };

    const colors = ['#F01818', '#000000', '#36A2E0', '#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    return (
        <ResponsiveContainer height={600} className="serie-history-chart">
            <RadarChart cx="50%" cy="50%" outerRadius="70%" data={chartData} >
                <PolarGrid
                    gridType= "circle"
                />
                <PolarAngleAxis
                    dataKey="subject"
                />
                <PolarRadiusAxis angle={90} domain={[0, 100]} />
                {serieHistory.map((entry, index) => {
                    const dataKey = `history_${index}`;
                    const isHidden = hiddenSeries.includes(dataKey);
                    const name = `${entry.user.firstName} ${entry.user.lastName} - ${new Date(entry.date).toLocaleDateString()}`;
                    return (
                        <Radar
                            key={dataKey}
                            name={name}
                            dataKey={dataKey}
                            stroke={colors[index % colors.length]}
                            fill={colors[index % colors.length]}
                            fillOpacity={0}
                            strokeOpacity={isHidden ? 0 : 1}
                            legendType="circle"
                            dot={!isHidden}
                        />
                    );
                })}
                <Tooltip content={<CustomTooltip />} />
                <Legend
                    onClick={handleLegendClick}
                    formatter={legendFormatter}
                    layout= "vertical"
                    align="right"
                    verticalAlign="middle"
                />
            </RadarChart>
        </ResponsiveContainer>
    );
}

const CustomTooltip = ({ active, payload, label }) => {
    if(active && payload && payload.length) {
        return (
            <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                <h2>{`Compétence: ${label}`}</h2>
                {
                    payload.map((entry, index) => (
                        <p key={`item-${index}`} style={{ color: entry.color }}>
                            {`${entry.name} : ${entry.value.toFixed(0)}%`}
                        </p>
                    ))
                }
            </div>
        );
    }

    return null;
};

SerieHistoryBySkillChart.propTypes = {
    serieHistory: PropTypes.array.isRequired
};
